import { ChevronLeft, Users } from 'lucide-react';
import { ReferralPanel } from './RewardsTab';

export default function ReferralsTab({ user, copyReferral, goBack }) {
  const referralCount = user?.referral_count ?? user?.referrals_count ?? user?.referralCount ?? 0;

  return (
    <div
      className="vl-pirate-page vl-referrals-page space-y-5 pb-28 sm:pb-10"
      style={{ animation: 'fadeInUp 0.4s ease' }}
      data-testid="referrals-tab"
    >
      <header className="vl-rewards-page__masthead vl-referrals-page__masthead">
        <span><Users /></span>
        <div>
          <p>Crew Invites</p>
          <h1>Referrals</h1>
        </div>
        <i className="vl-page-masthead__lantern" aria-hidden="true" />
      </header>

      <button
        onClick={goBack}
        className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition"
        data-testid="referrals-back"
      >
        <ChevronLeft className="w-4 h-4" /> Back
      </button>

      <ReferralPanel user={user} referralCount={referralCount} copyReferral={copyReferral} />
    </div>
  );
}
